query MobileSdkFilterOptions($limit: Int = 1000) {
	msdk_report_runs(limit: $limit) {
		app_any
		app_version_any
		sdk_type_group_uniq_array
		product_version_any
	}
}
